export function groupBy<K extends PropertyKey, T>(
    items: Iterable<T>,
    keySelector: (item: T, index: number) => K,
): Partial<Record<K, T[]>> {
    const result = {} as Partial<Record<K, T[]>>
    let index = 0
    for (const item of items) {
        const selectedKey = keySelector(item, index)
        if (!(selectedKey in result)) {
            result[selectedKey] = [] as T[]
        }
        result[selectedKey]?.push(item)
        index = index + 1
    }
    return result
}
